import { useTranslate } from 'react-polyglot'
import { Button, ButtonProps, Typography } from '@getgo/chameleon-web-react-wrapper'

import CopilotLogo from 'assets/copilot_ai_logo.svg'

import './AskCopilotButton.css'

interface AskCopilotButtonProps extends ButtonProps {
  isCopilotOpen?: boolean
}

const AskCopilotButton = ({ ...props }: AskCopilotButtonProps): JSX.Element => {
  const t = useTranslate()

  //TODO change active color based on isCopilotOpen once we get the icon in chameleon
  return (
    <Button
      id="copilot-text-field"
      fullWidth
      variant="tertiary"
      size="medium"
      leadingIcon={<CopilotLogo style={{ paddingTop: '7px' }} />}
      style={{ marginRight: '15px' }}
      {...props}
    >
      <Typography className="ask-copilot-button-text" variant="button-small">
        {t('Ask GoPilot')}
      </Typography>
    </Button>
  )
}

export default AskCopilotButton
